const projects = [
  {
    name: 'How Much To Make A Video',
    link: 'https://howmuchtomakeavideo.com/',
    workedOn: 'everything'
  },
  {
    name: 'OhTell',
    link: 'https://www.producthunt.com/tech/ohtell',
    workedOn: 'code for app + mobile'
  },
  {
    name: 'uCourse',
    link: 'http://www.ucourse.nl/',
    workedOn: 'code for internal tool'
  },
  {
    name: 'Ginger Payments',
    link: 'https://www.gingerpayments.com/',
    workedOn: 'migration to Angular.js'
  },
  {
    name: 'Optima',
    link: 'http://www.optimamodel.com/',
    workedOn: 'code for internal tool'
  },
  {
    name: 'SwipeGuide',
    link: 'http://swipeguide.com',
    workedOn: 'code for internal tool + mobile'
  },
  {
    name: 'Moj Termin',
    link: 'http://mojtermin.mk/map',
    workedOn: 'interactive dynamic map'
  },
  {
    name: 'SnapScan',
    link: 'https://snapscan.com.au/',
    workedOn: 'complete FE'
  },
  {
    name: 'Circle Market',
    link: 'https://circle-market.com/',
    workedOn: 'implementation in React + MobX'
  }
];

export default projects;


// WEBPACK FOOTER //
// ./src/data/projects.js